import React from "react"
import { useRecoilState } from "recoil"
import { useHistory } from "react-router-dom"
import clsx from "clsx"
import { makeStyles } from "@material-ui/core/styles"
import Divider from "@material-ui/core/Divider"
import Drawer from "@material-ui/core/Drawer"
import IconButton from "@material-ui/core/IconButton"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
// import HomeIcon from "@material-ui/icons/Home"
import DiscussionIcon from "@material-ui/icons/Forum"
import DocumentsIcon from "@material-ui/icons/InsertDriveFile"
import InviteIcon from "@material-ui/icons/AlternateEmail"
import SaleIcon from "@material-ui/icons/LocalOffer"
// import AnnouncementsIcon from "@material-ui/icons/Announcement"
// import SettingsIcon from "@material-ui/icons/Settings"

import Logo from "../components/Logo"
import SiteHeader from "../components/SiteHeader"
import SiteHeaderSpacer from "../components/SiteHeaderSpacer"
import { navMain } from "../store/navMain"

const drawerWidth = 220

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
    },
    contentWrap: {
      flexGrow: 1,
      position: "relative",
    },
    content: {
      padding: theme.spacing(3),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    divider: {
      backgroundColor: "rgba(255, 255, 255, 0.12)",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerIconButton: {},
    drawerIcons: {
      color: theme.palette.primary.contrastText,
    },
    paper: {
      background: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(7) + 1,
      },
    },
    toolbar: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: 0,
      position: "relative",
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  }
})

const NavListItems = (props) => {
  const { items } = props

  return (
    <>
      {items.map((item) => (
        <ListItem button key={item.text} onClick={item.click}>
          <ListItemIcon>{item.icon ? item.icon : ""}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItem>
      ))}
    </>
  )
}

export default function Layout({ title, children, options = null, ...props }) {
  const matches = useMediaQuery("(max-width:600px)")
  const history = useHistory()
  const classes = useStyles()
  const [open, setOpen] = useRecoilState(navMain)

  React.useEffect(() => {
    if (matches) {
      setOpen(false)
    }
  }, [matches, setOpen])

  const handleDrawerClose = () => {
    setOpen(false)
  }

  const mainItems = [
    // {
    //   icon: <HomeIcon className={classes.drawerIcons} />,
    //   click: () => history.push("/0"),
    //   text: "Dashboard",
    // },
    {
      icon: <DiscussionIcon className={classes.drawerIcons} />,
      click: () => history.push("/0/discussion"),
      text: "Discussion",
    },
    {
      icon: <DocumentsIcon className={classes.drawerIcons} />,
      click: () => history.push("/0/documents"),
      text: "Documents",
    },
  ]
  const boardItems = [
    {
      icon: <InviteIcon className={classes.drawerIcons} />,
      click: () => history.push("/0/invite"),
      text: "Invite Members",
    },
    {
      icon: <SaleIcon className={classes.drawerIcons} />,
      click: () => history.push("/0/sale"),
      text: "Sale Disclosures",
    },
    // {
    //   icon: <AnnouncementsIcon className={classes.drawerIcons} />,
    //   click: () => history.push("/0/announcements"),
    //   text: "Announcements",
    // },
    // {
    //   icon: <SettingsIcon className={classes.drawerIcons} />,
    //   click: () => history.push("/0/settings"),
    //   text: "Settings",
    // },
  ]

  return (
    <div className={classes.root}>
      <SiteHeader title={title} />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx(classes.paper, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {" "}
          <Logo open={open} />
          <IconButton className={classes.drawerIconButton} onClick={handleDrawerClose}>
            {open ? <ChevronLeftIcon className={classes.drawerIcons} /> : ""}
          </IconButton>
        </div>
        <Divider className={classes.divider} />
        <List>
          <NavListItems classes items={mainItems} />
        </List>
        <Divider className={classes.divider} />
        <List>
          <NavListItems classes items={boardItems} />
        </List>
        <Divider className={classes.divider} />
      </Drawer>
      <main className={classes.contentWrap}>
        <SiteHeaderSpacer />
        {children}
      </main>
    </div>
  )
}
